'use strict';

var jsxRuntime = require('react/jsx-runtime');
var components_flexBox_FlexBox = require('../flexBox/FlexBox.js');
var theme_index = require('../../_chunks/index-CIVOGJRG.js');
require('react');
require('../../_chunks/InternalFlexBox-BDDWEQ9L.js');
require('../../_chunks/combineClasses-5P8GTQkg.js');
require('../../_chunks/designTokens-CKP-YoT2.js');

const coverGapVariable = `--cover-gap`;
/**
 * Use this layout when you want to vertically center content within a container with a minimum height.
 * https://storybook.templafy.com/?path=/docs/layouts-cover--absolutely-centered-form
 */
const Cover = ({ children, minHeight = '100vh', gap = '300', padding = gap, className, style, ...flexBoxProps }) => {
    return (jsxRuntime.jsx(components_flexBox_FlexBox.FlexBox, { className: className, style: {
            ...style,
            minHeight,
            [coverGapVariable]: theme_index.theme.spacing[gap],
            padding: theme_index.theme.spacing[padding],
        }, ...flexBoxProps, flexDirection: "column", children: children }));
};
const Header = ({ children, style, ...flexboxProps }) => (jsxRuntime.jsx(components_flexBox_FlexBox.FlexBox, { style: {
        ...style,
        marginTop: 0,
        marginBottom: `var(${coverGapVariable})`,
    }, flexDirection: "column", ...flexboxProps, children: children }));
const Center = ({ children, style, ...flexboxProps }) => (jsxRuntime.jsx(components_flexBox_FlexBox.FlexBox, { style: {
        ...style,
        marginTop: 'auto',
        marginBottom: 'auto',
    }, flexDirection: "column", ...flexboxProps, children: children }));
const Footer = ({ children, style, ...flexboxProps }) => (jsxRuntime.jsx(components_flexBox_FlexBox.FlexBox, { style: {
        ...style,
        marginTop: `var(${coverGapVariable})`,
        marginBottom: 0,
    }, flexDirection: "column", ...flexboxProps, children: children }));
Cover.Header = Header;
Cover.Header.displayName = 'Cover.Header';
Cover.Center = Center;
Cover.Center.displayName = 'Cover.Center';
Cover.Footer = Footer;
Cover.Footer.displayName = 'Cover.Footer';

exports.Cover = Cover;
//# sourceMappingURL=Cover.js.map
